import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function BackButton() {
  const navigate = useNavigate();
  return (
    <div
      className="back-button"
      onClick={() => {
        navigate(-1);
      }}
    >
      <ArrowBackIcon sx={{ color: "white", fontSize: 30 }} />
    </div>
  );
}

export default BackButton;
